import PropTypes from 'prop-types';
import React from 'react';
import { ImportantMessageFragment } from 'app/graphql/__generated__/types/contento';
import ImportantMessage from './ImportantMessage';
import { useLocalStorage } from '../../hooks/useLocalStorage';
import { StyledImportantMessagesContainer } from './ImportantMessage.styles';

const getCombinedId = (message): string | undefined =>
    message.id ? `${message.id}-${message.updated}-${message.created}` : undefined;

const ImportantMessages = ({ messages = [] }: { messages: Array<ImportantMessageFragment> }) => {
    const [read, setRead] = useLocalStorage<{ [key: string]: boolean }>('readImportantMessage', {});
    const readMessages = Object.keys(read);

    const handleOnClose = (combinedId) => {
        const newValue = { ...read, [combinedId]: true };
        setRead(newValue);
    };

    if (!messages || messages.length === 0) {
        return null;
    }

    return (
        <StyledImportantMessagesContainer id="important-messages" role="complementary">
            {messages.map((message, index) => {
                const id = getCombinedId(message);
                const isRead = id ? readMessages.includes(id) : false;

                return (
                    <ImportantMessage
                        key={index}
                        // eslint-disable-next-line react/jsx-props-no-spreading
                        {...message}
                        combinedId={getCombinedId(message)}
                        isRead={isRead}
                        onClose={handleOnClose}
                    />
                );
            })}
        </StyledImportantMessagesContainer>
    );
};

ImportantMessages.propTypes = {
    messages: PropTypes.array,
};

export default ImportantMessages;
